module.exports = __webpack_public_path__ + "img/background-azul-escuro-reduzido-2.1554dd93.jpg";